import React, { Component } from "react";
import PaymentSuccessful from "./paymentSuccessful";
import PaymentFailed from "./paymentFailed";
import Spinner from "../Spinner/Spinner";

class PaymentResult extends Component {
  state = {
    result: null,
    orderPrice: null,
  };
  componentDidMount() {
    this.setState({
      result: new URLSearchParams(this.props.location.search).get("status"),
      orderPrice: +localStorage.getItem("orderPrice"),
    });
  }
  render() {
    return (
      <>
        {!this.state.result ? (
          <Spinner />
        ) : this.state.result === "failed" ? (
          <PaymentFailed price={this.state.orderPrice} />
        ) : (
          <PaymentSuccessful
            price={this.state.orderPrice}
            result={this.state.result}
          />
        )}
      </>
    );
  }
}

export default PaymentResult;
